import * as tslib_1 from "tslib";
import selectShortcutsOption from '../data/mutators/selectShortcutsOption';
import getKeyboardShortcutsOptions from '../data/store/store';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { lazySetIsHotkeysMapVisible } from 'owa-hotkeys-map';
import { OptionDescription } from 'owa-options-controls';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var styles = require('./KeyboardShortcutsFull.scss');
var KeyboardShortcutsFull = /** @class */ (function (_super) {
    tslib_1.__extends(KeyboardShortcutsFull, _super);
    function KeyboardShortcutsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyboardShortcutsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var selectedKey = "" + getFallbackValueIfNull(optionState.shortcuts, userOptions.KeyboardShortcutsMode);
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_shortcuts_description),
            React.createElement(ChoiceGroup, { label: strings.options_shortcuts_label, selectedKey: selectedKey, options: [
                    {
                        key: "" + 0 /* Hotmail */,
                        text: strings.options_shortcut_choice_hotmail,
                    },
                    {
                        key: "" + 2 /* Yahoo */,
                        text: strings.options_shortcut_choice_yahoo,
                    },
                    {
                        key: "" + 3 /* Gmail */,
                        text: strings.options_shortcut_choice_gmail,
                    },
                    {
                        key: "" + 4 /* Owa */,
                        text: strings.options_shortcut_choice_outlook,
                    },
                    {
                        key: "" + 1 /* Off */,
                        text: strings.options_shortcut_choice_off,
                    },
                ], onChange: this.onChange }),
            userOptions.KeyboardShortcutsMode !== 1 /* Off */ && (React.createElement("div", { className: styles.fullListCta },
                React.createElement("span", null, strings.options_shortcut_cta_shorcuts),
                React.createElement(Link, { onClick: function () {
                        lazySetIsHotkeysMapVisible.importAndExecute(true);
                    } }, strings.options_shortcut_cta_shorcuts_click)))));
    };
    KeyboardShortcutsFull.prototype.onChange = function (ev, option) {
        selectShortcutsOption(parseInt(option.key, 10));
    };
    KeyboardShortcutsFull = tslib_1.__decorate([
        reactive({
            userOptions: function () { return getUserConfiguration().UserOptions; },
            optionState: function () { return getKeyboardShortcutsOptions(); },
        })
    ], KeyboardShortcutsFull);
    return KeyboardShortcutsFull;
}(React.Component));
export default KeyboardShortcutsFull;
//# sourceMappingURL=KeyboardShortcutsFull.js.map